export enum AdyenPaymentMethodType {
    trustly = 'trustly',
    scheme = 'scheme',
    swish = 'swish',
    vipps = 'vipps',
    mobilepay = 'mobilepay',
    ideal = 'ideal',
    bancontact_mistercash_and_maestro = 'bcmc',
    eps = 'eps',
    giropay ='giropay',
    blik ='blik',
    Walley = 'walley',
    twint = 'twint',
    riverty = 'riverty',
    GooglePay_Adyen = 'GooglePay_Adyen',
    ApplePay_Adyen = 'ApplePay_Adyen'
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/adyen-payment-method-type.eum.ts